import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getZohoCredential = createAsyncThunk(
    "zohoCredentials/getAllZohoCredentials",
    async (businessIdState) => {
        const response = await axios.get(
            `${baseURL}/api/lead/zoho/auth-url`,
            RequestConfig(),
        );
        return response.data;
    },
);
